module.exports = __webpack_public_path__ + "static/media/souls.e034d8bf.png";